import IntroductionsInfoModal from "./IntroductionsInfoModal";

export default IntroductionsInfoModal;
